import { cva, type VariantProps } from "class-variance-authority";

export interface IconProps extends VariantProps<typeof iconVariants> {}

type Color =
  | "action-500"
  | "action-800"
  | "accent-500"
  | "danger-500"
  | "danger-600"
  | "font-secondary"
  | "font-tertiary"
  | "information-500"
  | "information-800"
  | "inherit"
  | "navigation-400"
  | "neutral-0"
  | "neutral-400"
  | "neutral-900"
  | "success-500"
  | "success-800"
  | "warning-400"
  | "warning-500";

const iconColorMap: Record<Color, string> = {
  "action-500": "text-action-500",
  "action-800": "text-action-800",
  "accent-500": "text-accent-500",
  "danger-500": "text-danger-500",
  "danger-600": "text-danger-600",
  "font-secondary": "text-font-secondary",
  "font-tertiary": "text-font-tertiary",
  "information-500": "text-information-500",
  "information-800": "text-information-800",
  inherit: "text-inherit",
  "navigation-400": "text-navigation-400",
  "neutral-0": "text-neutral-0",
  "neutral-400": "text-neutral-400",
  "neutral-900": "text-neutral-900",
  "success-500": "text-success-500",
  "success-800": "text-success-800",
  "warning-400": "text-warning-400",
  "warning-500": "text-warning-500",
};

export const iconVariants = cva("", {
  variants: {
    shrink: {
      noShrink: "shrink-0",
    },
    animate: {
      spin: "animate-spin",
      wiggle: "hover:paused motion-safe:animate-wiggle",
      forge: "origin-bottom-left motion-safe:animate-forge",
    },
    size: {
      "2xs": "size-2.5",
      xs: "size-3",
      s: "size-4",
      m: "size-5",
      hero: "size-20",
      "large-hero": "size-50",
    },
    color: {
      "action-500": iconColorMap["action-500"],
      "action-800": iconColorMap["action-800"],
      "accent-500": iconColorMap["accent-500"],
      "danger-500": iconColorMap["danger-500"],
      "danger-600": iconColorMap["danger-600"],
      "font-secondary": iconColorMap["font-secondary"],
      "font-tertiary": iconColorMap["font-tertiary"],
      "information-500": iconColorMap["information-500"],
      "information-800": iconColorMap["information-800"],
      inherit: iconColorMap.inherit,
      "navigation-400": iconColorMap["navigation-400"],
      "neutral-0": iconColorMap["neutral-0"],
      "neutral-400": iconColorMap["neutral-400"],
      "neutral-900": iconColorMap["neutral-900"],
      "success-500": iconColorMap["success-500"],
      "success-800": iconColorMap["success-800"],
      "warning-400": iconColorMap["warning-400"],
      "warning-500": iconColorMap["warning-500"],
    },
    transition: {
      colors: "transition-colors",
    },
  },
  defaultVariants: { size: "m", color: "inherit", shrink: "noShrink" },
});
